// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"315":"6d281efe","787":"a7d82f77","854":"2ce5b9ac"}[chunkId] + ".chunk.js";
};